import Breadcrumb from "../../Component/Breadcrumb";

function Infirmary() {
  return (
    <>
      <Breadcrumb>Students / Infirmary</Breadcrumb>
      <div className="innersec admission_sec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Infirmary</h1>
          </div>
          <p>
            A well-equipped medical room, separately for boys and girls, takes
            care of all minor ailments and also deals with emergencies during
            school hours. Doctors are available on call, to meet any emergency
            and regular medical check-up is carried out for the benefit of the
            children.
          </p>
        </div>
      </div>
    </>
  );
}
export default Infirmary;
